import { render } from "./TrainingRecord.vue?vue&type=template&id=572e0b95&scoped=true"
import script from "./TrainingRecord.vue?vue&type=script&lang=js"
export * from "./TrainingRecord.vue?vue&type=script&lang=js"

import "./TrainingRecord.vue?vue&type=style&index=0&id=572e0b95&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572e0b95"]])

export default __exports__